import { api } from '../../../servicesGlobais/api'
import {
  Calendario,
  SolicitacaoAjuste,
  SolicitacaoFiltros,
  ValorDiaria,
  RelatorioPreview,
  Lote,
  LotesResultado,
  PessoaOption,
} from '../tipos/ajudaCusto'

export const ajudaCustoService = {
  async obterCalendario(ano: number, mes: number): Promise<Calendario> {
    return await api.get<Calendario>(`/AjudaCusto/calendario?ano=${ano}&mes=${mes}`)
  },

  async registrarHoje(): Promise<void> {
    await api.post('/AjudaCusto/registro/hoje')
  },

  async solicitarAjuste(data: string, justificativa: string): Promise<void> {
    await api.post('/AjudaCusto/solicitacao', { data, justificativa })
  },

  async obterSolicitacoes(filtros?: SolicitacaoFiltros): Promise<SolicitacaoAjuste[]> {
    const params = new URLSearchParams()
    if (filtros?.status != null) params.append('status', String(filtros.status))
    if (filtros?.pessoaId != null) params.append('pessoaId', String(filtros.pessoaId))
    if (filtros?.dataInicio) params.append('dataInicio', filtros.dataInicio)
    if (filtros?.dataFim) params.append('dataFim', filtros.dataFim)
    const qs = params.toString()
    const data = await api.get<SolicitacaoAjuste[]>(`/AjudaCusto/solicitacoes${qs ? `?${qs}` : ''}`)
    return Array.isArray(data) ? data : []
  },

  async aprovarSolicitacao(id: number): Promise<void> {
    await api.post(`/AjudaCusto/solicitacao/${id}/aprovar`)
  },

  async reprovarSolicitacao(id: number, motivo: string): Promise<void> {
    await api.post(`/AjudaCusto/solicitacao/${id}/reprovar`, { motivo })
  },

  async lancarRegistroManual(pessoaId: number, data: string): Promise<void> {
    await api.post('/AjudaCusto/registro/manual', { pessoaId, data })
  },

  async removerRegistro(id: number): Promise<void> {
    await api.delete(`/AjudaCusto/registro/${id}`)
  },

  async buscarRelatorio(dataInicio: string, dataFim: string, pessoaId?: number): Promise<RelatorioPreview> {
    const params = new URLSearchParams({ dataInicio, dataFim })
    if (pessoaId != null) params.append('pessoaId', String(pessoaId))
    return await api.get<RelatorioPreview>(`/AjudaCusto/relatorio/buscar?${params.toString()}`)
  },

  async gerarLote(dataInicio: string, dataFim: string, pessoaId?: number): Promise<Lote> {
    return await api.post<Lote>('/AjudaCusto/relatorio/gerar-lote', { dataInicio, dataFim, pessoaId })
  },

  async obterLotes(): Promise<LotesResultado> {
    return await api.get<LotesResultado>('/AjudaCusto/relatorio/lotes')
  },

  async obterValoresDiaria(): Promise<ValorDiaria[]> {
    const data = await api.get<ValorDiaria[]>('/AjudaCusto/valor-diaria')
    return Array.isArray(data) ? data : []
  },

  async criarValorDiaria(dto: { valor: number; dataInicioVigencia: string; dataFimVigencia: string }): Promise<ValorDiaria> {
    return await api.post<ValorDiaria>('/AjudaCusto/valor-diaria', dto)
  },

  async atualizarValorDiaria(
    id: number,
    dto: { valor: number; dataInicioVigencia: string; dataFimVigencia: string },
  ): Promise<ValorDiaria> {
    return await api.put<ValorDiaria>(`/AjudaCusto/valor-diaria/${id}`, dto)
  },

  async excluirValorDiaria(id: number): Promise<void> {
    await api.delete(`/AjudaCusto/valor-diaria/${id}`)
  },

  async listarPessoas(): Promise<PessoaOption[]> {
    // Endpoint já exclui pessoas vinculadas ao time Momentum (filtro por TimePessoas no backend)
    const data = await api.get<any[]>('/AjudaCusto/pessoas')
    if (!Array.isArray(data)) return []
    return data
      .map((p) => ({ idPessoa: p.idPessoa ?? p.IdPessoa, nome: p.nome ?? p.Nome ?? '' }))
      .filter((p) => p.idPessoa != null)
  },
}
